import { render } from "./MyBusSeat.vue?vue&type=template&id=a3fafc06&scoped=true"
import script from "./MyBusSeat.vue?vue&type=script&lang=js"
export * from "./MyBusSeat.vue?vue&type=script&lang=js"

import "./MyBusSeat.vue?vue&type=style&index=0&id=a3fafc06&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3fafc06"]])

export default __exports__